import { Link, Navigate, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowLeft } from "lucide-react";
import { patientQueryKeys, patientsApi } from "../../shared/api/patients";
import { PatientForm } from "./components/PatientForm";
import { apiError } from "../../shared/api/client";
import { Button } from "@/components/ui/button";

export function PatientEditPage() {
  const { id } = useParams<{ id: string }>();
  const query = useQuery({
    queryKey: patientQueryKeys.detail(id ?? ""),
    queryFn: () => patientsApi.get(id ?? ""),
    enabled: !!id,
  });
  // Guard AFTER hooks so hook order is stable (Rules of Hooks / React #310).
  if (!id) return <Navigate to="/patients" replace />;

  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div className="space-y-1">
          <h1 className="text-2xl font-semibold tracking-tight text-foreground">
            Sửa hồ sơ bệnh nhân
          </h1>
          <p className="text-sm text-muted-foreground">
            Cập nhật thông tin nhân khẩu, liên hệ, ghi chú y khoa. Mọi thay đổi đều được ghi vào audit log.
          </p>
        </div>
        <div className="shrink-0">
          <Button asChild variant="outline">
            <Link to={`/patients/${id}`}>
              <ArrowLeft />
              Hồ sơ
            </Link>
          </Button>
        </div>
      </div>

      {query.isLoading && (
        <p className="text-sm text-muted-foreground">Đang tải hồ sơ…</p>
      )}
      {query.isError && (
        <div className="rounded-md border border-destructive/30 bg-destructive/10 px-3 py-2 text-sm text-destructive">
          {apiError(query.error).detail}
        </div>
      )}
      {query.data && (
        <PatientForm
          mode="edit"
          initial={query.data}
          onSuccessRedirect={(pid) => `/patients/${pid}`}
        />
      )}
    </div>
  );
}
